import { render, staticRenderFns } from "./seconDkill.vue?vue&type=template&id=04d46dab&scoped=true&"
import script from "./seconDkill.vue?vue&type=script&lang=js&"
export * from "./seconDkill.vue?vue&type=script&lang=js&"
import style0 from "./seconDkill.vue?vue&type=style&index=0&id=04d46dab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d46dab",
  null
  
)

export default component.exports